export default __webpack_public_path__ + "static/media/github.8e2a9e7d.png";